// removed by extract-text-webpack-plugin
module.exports = {"xl":"size__xl___3oHdO fontSize-l height-control--xl lineHeight-control--xl","l":"size__l___3F-gT fontSize-m height-control--l lineHeight-control--l","m":"size__m___1EcFf fontSize-m height-control--m lineHeight-control--m","s":"size__s___2MdHR fontSize-s height-control--s lineHeight-control--s","xs":"size__xs___K0A6W fontSize-xs height-control--xs lineHeight-control--xs"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-select/Select/style/size.css
// module id = 235
// module chunks = 0 8